import { createFormHook as e, createFormHookContexts as t } from "@tanstack/react-form";
import { DsAlert as n, DsButton as r, DsCheckbox as i, DsCheckboxGroup as a, DsDatePicker as o, DsDateRangePicker as s, DsDateTimePicker as c, DsNumberField as ee, DsPinInput as l, DsRadio as u, DsRadioGroup as d, DsSelect as f, DsSelectItem as te, DsSwitch as p, DsTextArea as m, DsTextField as ne } from "@frontends/ds";
import { Fragment as re, jsx as h, jsxs as ie } from "react/jsx-runtime";
import { getApiErrorMessage as ae, transformToApiError as oe } from "@frontends/util-api-errors";
import { useMemo as se, useRef as g } from "react";
import { Form as ce, useLocale as le } from "react-aria-components";
import { getLocalTimeZone as ue } from "@internationalized/date";
import { useTranslation as de } from "react-i18next";
import * as _ from "valibot";
//#region src/lib/context/formContexts.ts
var { fieldContext: v, formContext: y, useFieldContext: b, useFormContext: x } = t();
//#endregion
//#region src/lib/helpers/getErrorText.ts
function S(e) {
	for (let t of e) {
		if (typeof t == "string" && t.length > 0) return t;
		if (t && typeof t == "object" && "message" in t) {
			let e = t.message;
			if (typeof e == "string" && e.length > 0) return e;
		}
	}
}
//#endregion
//#region src/lib/helpers/getFieldErrorText.ts
function C(e) {
	if (e.state.meta.isTouched) return S(e.state.meta.errors);
}
//#endregion
//#region src/lib/fields/FormCheckbox.tsx
function w(e) {
	let t = b(), n = C(t);
	return /* @__PURE__ */ h(i, {
		...e,
		name: t.name,
		isSelected: t.state.value,
		onChange: t.handleChange,
		onBlur: t.handleBlur,
		isInvalid: n !== void 0,
		errorMessage: n
	});
}
//#endregion
//#region src/lib/fields/FormCheckboxGroup.tsx
function T(e) {
	let t = b(), n = C(t);
	return /* @__PURE__ */ h(a, {
		...e,
		name: t.name,
		value: t.state.value,
		onChange: t.handleChange,
		onBlur: t.handleBlur,
		isInvalid: n !== void 0,
		errorMessage: n
	});
}
//#endregion
//#region src/lib/fields/FormDatePicker.tsx
function E(e) {
	let t = b(), n = C(t);
	return /* @__PURE__ */ h(o, {
		isFullWidth: !0,
		...e,
		name: t.name,
		value: t.state.value,
		onChange: t.handleChange,
		onBlur: t.handleBlur,
		isInvalid: n !== void 0,
		errorMessage: n
	});
}
//#endregion
//#region src/lib/fields/FormDateRangePicker.tsx
function D(e) {
	let t = b(), n = C(t);
	return /* @__PURE__ */ h(s, {
		isFullWidth: !0,
		...e,
		value: t.state.value,
		onChange: t.handleChange,
		onBlur: t.handleBlur,
		isInvalid: n !== void 0,
		errorMessage: n
	});
}
//#endregion
//#region src/lib/fields/FormDateTimePicker.tsx
function O(e) {
	let t = b(), n = C(t);
	return /* @__PURE__ */ h(c, {
		isFullWidth: !0,
		...e,
		name: t.name,
		value: t.state.value,
		onChange: t.handleChange,
		onBlur: t.handleBlur,
		isInvalid: n !== void 0,
		errorMessage: n
	});
}
//#endregion
//#region src/lib/fields/FormNumberField.tsx
function k(e) {
	let t = b(), n = C(t);
	return /* @__PURE__ */ h(ee, {
		isFullWidth: !0,
		...e,
		name: t.name,
		value: t.state.value,
		onChange: t.handleChange,
		onBlur: t.handleBlur,
		isInvalid: n !== void 0,
		errorMessage: n
	});
}
//#endregion
//#region src/lib/fields/FormPinInput.tsx
function A(e) {
	let t = b(), n = C(t);
	return /* @__PURE__ */ h(l, {
		...e,
		name: t.name,
		value: t.state.value,
		onChange: t.handleChange,
		onBlur: t.handleBlur,
		isInvalid: n !== void 0,
		errorMessage: n
	});
}
//#endregion
//#region src/lib/fields/FormRadioGroup.tsx
function j(e) {
	let t = b(), n = C(t);
	return /* @__PURE__ */ h(d, {
		...e,
		name: t.name,
		value: t.state.value,
		onChange: t.handleChange,
		onBlur: t.handleBlur,
		isInvalid: n !== void 0,
		errorMessage: n
	});
}
//#endregion
//#region src/lib/fields/FormSelect.tsx
function M(e) {
	let t = b(), n = C(t);
	return /* @__PURE__ */ h(f, {
		isFullWidth: !0,
		...e,
		name: t.name,
		value: t.state.value,
		onChange: t.handleChange,
		onBlur: t.handleBlur,
		isInvalid: n !== void 0,
		errorMessage: n
	});
}
//#endregion
//#region src/lib/fields/FormSwitch.tsx
function N(e) {
	let t = b(), n = C(t);
	return /* @__PURE__ */ h(p, {
		...e,
		name: t.name,
		isSelected: t.state.value,
		onChange: t.handleChange,
		onBlur: t.handleBlur,
		isInvalid: n !== void 0,
		errorMessage: n
	});
}
//#endregion
//#region src/lib/fields/FormTextArea.tsx
function P(e) {
	let t = b(), n = C(t);
	return /* @__PURE__ */ h(m, {
		isFullWidth: !0,
		...e,
		name: t.name,
		value: t.state.value,
		onChange: t.handleChange,
		onBlur: t.handleBlur,
		isInvalid: n !== void 0,
		errorMessage: n
	});
}
//#endregion
//#region src/lib/fields/FormTextField.tsx
function F(e) {
	let t = b(), n = C(t);
	return /* @__PURE__ */ h(ne, {
		isFullWidth: !0,
		...e,
		name: t.name,
		value: t.state.value,
		onChange: t.handleChange,
		onBlur: t.handleBlur,
		isInvalid: n !== void 0,
		errorMessage: n
	});
}
//#endregion
//#region src/lib/form/FormErrorSummary.tsx
function I(e) {
	return /* @__PURE__ */ h(x().Subscribe, {
		selector: (e) => e.errorMap.onSubmit,
		children: (t) => {
			let r = S([t]);
			return r ? /* @__PURE__ */ h(n, {
				...e,
				variant: "danger",
				description: r
			}) : null;
		}
	});
}
//#endregion
//#region src/lib/form/FormSubmitButton.tsx
function L(e) {
	return /* @__PURE__ */ h(x().Subscribe, {
		selector: (e) => [e.canSubmit, e.isSubmitting],
		children: ([t, n]) => /* @__PURE__ */ h(r, {
			...e,
			type: "submit",
			isDisabled: e.isDisabled || !t,
			isPending: n
		})
	});
}
//#endregion
//#region src/lib/createAppForm.ts
var { useAppForm: R, withForm: z } = e({
	fieldContext: v,
	formContext: y,
	fieldComponents: {
		Checkbox: w,
		CheckboxGroup: T,
		DatePicker: E,
		DateRangePicker: D,
		DateTimePicker: O,
		NumberField: k,
		PinInput: A,
		RadioGroup: j,
		Select: M,
		Switch: N,
		TextArea: P,
		TextField: F
	},
	formComponents: {
		ErrorSummary: I,
		SubmitButton: L
	}
});
//#endregion
//#region src/lib/errors/toFormErrors.ts
function B(e, t) {
	return Object.prototype.hasOwnProperty.call(e.state.fieldMeta, t);
}
function V(e, t, n = {}) {
	let { fallbackMessage: r = "", fieldMap: i } = n, { items: a } = oe(e), o = {}, s = [];
	for (let e of a) {
		let n = e.field ? i?.[e.field] ?? e.field : void 0;
		n && B(t, n) ? o[n] ??= e.detail : s.push(e.detail);
	}
	let c = Object.keys(o).length > 0;
	return {
		form: (() => {
			if (s.length > 0) return s.join(" ");
			if (!c) return ae(e, r) || void 0;
		})(),
		fields: o
	};
}
//#endregion
//#region src/lib/form/toSubmitHandler.ts
function H(e) {
	return Object.entries(e.state.fieldMeta).filter(([, e]) => e !== void 0 && e.errors.length > 0).map(([e]) => e);
}
function U(e) {
	return e instanceof HTMLInputElement && e.type === "hidden" || e.closest("[data-react-aria-prevent-focus]") ? !1 : e.offsetParent !== null || e === document.activeElement;
}
var W = "input:not([type=\"hidden\"]), button, [role=\"combobox\"], [tabindex=\"0\"]";
function fe(e) {
	if (U(e)) return e;
	let t = e.previousElementSibling;
	if (t instanceof HTMLElement) {
		let e = t.matches(W) ? t : t.querySelector(W);
		if (e && U(e)) return e;
	}
	let n = e.closest("[data-rac], .group");
	return n ? n.querySelector(W) : null;
}
function pe(e, t) {
	if (t.length === 0) return;
	let n = new Set(t);
	for (let t of e.querySelectorAll("[name]")) {
		let e = t.getAttribute("name");
		if (!e || !n.has(e)) continue;
		let r = fe(t);
		if (r) {
			r.focus();
			return;
		}
	}
}
function G(e) {
	return (t) => {
		t.preventDefault(), t.stopPropagation();
		let n = t.currentTarget, r = () => {
			pe(n, H(e));
		};
		e.handleSubmit().then(r, (e) => {
			console.error(e), r();
		});
	};
}
//#endregion
//#region src/lib/types/constants.ts
var K = "form-common", me = {
	checkbox: !1,
	checkboxGroup: [],
	date: null,
	dateRange: null,
	dateTime: null,
	number: NaN,
	password: "",
	pin: "",
	radio: null,
	select: null,
	switch: !1,
	text: "",
	textarea: ""
};
//#endregion
//#region src/lib/config/buildDefaultValues.ts
function he(e) {
	let t = {};
	for (let [n, r] of Object.entries(e)) {
		let e = me[r.type];
		t[n] = r.defaultValue ?? (Array.isArray(e) ? [...e] : e);
	}
	return t;
}
//#endregion
//#region src/lib/helpers/dateValue.ts
function q(e) {
	return typeof e == "object" && !!e && "calendar" in e && "compare" in e;
}
function ge(e) {
	return "hour" in e;
}
function _e(e) {
	return "timeZone" in e ? e.timeZone : ue();
}
function J(e, t) {
	let n = _e(e);
	return new Intl.DateTimeFormat(t, {
		dateStyle: "medium",
		timeStyle: ge(e) ? "short" : void 0,
		timeZone: n
	}).format(e.toDate(n));
}
var ve = { errors: {
	dateMax: "Date must be on or before {{max}}",
	dateMin: "Date must be on or after {{min}}",
	email: "Enter a valid email address",
	invalid: "Check that the value is correct",
	maxLength: "Maximum {{max}} characters",
	minLength: "Minimum {{min}} characters",
	numberMax: "Maximum value is {{max}}",
	numberMin: "Minimum value is {{min}}",
	required: "This field is required",
	submitFailed: "Something went wrong. Please try again."
} };
//#endregion
//#region src/lib/i18n/useFormTranslation.ts
function ye(e, t) {
	let n = t.split(".").reduce((e, t) => {
		if (e && typeof e == "object") return e[t];
	}, e);
	return typeof n == "string" ? n : t;
}
function be(e, t) {
	return t ? e.replace(/\{\{(\w+)\}\}/g, (e, n) => n in t ? String(t[n]) : e) : e;
}
var xe = { t: ((e, t) => be(ye(ve, e), t)) };
function Y() {
	let e = de(K, { useSuspense: !1 });
	return e.ready ? e : xe;
}
//#endregion
//#region src/lib/i18n/useFormMessages.ts
function X() {
	let { t: e } = Y(), { locale: t } = le();
	return se(() => ({
		dateMax: (n) => e("errors.dateMax", { max: J(n, t) }),
		dateMin: (n) => e("errors.dateMin", { min: J(n, t) }),
		email: () => e("errors.email"),
		invalid: () => e("errors.invalid"),
		maxLength: (t) => e("errors.maxLength", { max: t }),
		minLength: (t) => e("errors.minLength", { min: t }),
		numberMax: (t) => e("errors.numberMax", { max: t }),
		numberMin: (t) => e("errors.numberMin", { min: t }),
		required: () => e("errors.required"),
		submitFailed: () => e("errors.submitFailed")
	}), [e, t]);
}
//#endregion
//#region src/lib/config/getDateBounds.ts
var Se = /* @__PURE__ */ new Set([
	"date",
	"dateTime",
	"dateRange"
]);
function Ce(e) {
	if (!Se.has(e.type)) return {};
	let t = {};
	for (let n of e.validators ?? []) typeof n == "object" && ("min" in n && q(n.min) && (t.minValue = n.min), "max" in n && q(n.max) && (t.maxValue = n.max));
	return t;
}
var we = {
	checkbox: {
		component: w,
		labelAsChildren: !0
	},
	checkboxGroup: {
		component: T,
		renderOptions: (e) => e.map((e) => /* @__PURE__ */ h(i, {
			value: e.value,
			children: e.label
		}, e.value))
	},
	date: { component: E },
	dateRange: { component: D },
	dateTime: { component: O },
	number: { component: k },
	password: {
		component: F,
		staticProps: { type: "password" }
	},
	pin: { component: A },
	radio: {
		component: j,
		renderOptions: (e) => e.map((e) => /* @__PURE__ */ h(u, {
			value: e.value,
			children: e.label
		}, e.value))
	},
	select: {
		component: M,
		renderOptions: (e) => e.map((e) => /* @__PURE__ */ h(te, {
			id: e.value,
			children: e.label
		}, e.value))
	},
	switch: {
		component: N,
		labelAsChildren: !0
	},
	text: { component: F },
	textarea: { component: P }
};
//#endregion
//#region src/lib/render/Field.tsx
function Te(e, t) {
	let n = we[e.type], r = n.component, i = {
		label: e.label,
		description: e.description,
		placeholder: e.placeholder,
		isDisabled: e.disabled,
		...n.staticProps,
		...Ce(e),
		...e.props,
		...t
	};
	if (n.renderOptions && "options" in e) return /* @__PURE__ */ h(r, {
		...i,
		children: n.renderOptions(e.options)
	});
	if (n.labelAsChildren) {
		let { label: e, ...t } = i;
		return /* @__PURE__ */ h(r, {
			...t,
			children: e
		});
	}
	return /* @__PURE__ */ h(r, { ...i });
}
//#endregion
//#region src/lib/render/FormRoot.tsx
function Ee({ api: e, renderAllFields: t }) {
	return function({ children: n, ...r }) {
		return /* @__PURE__ */ h(ce, {
			...r,
			validationBehavior: "aria",
			onSubmit: G(e),
			children: n ?? t()
		});
	};
}
//#endregion
//#region src/lib/render/buildInstance.tsx
function De(e, t) {
	function n({ name: n, ...r }) {
		let i = t.current.fields[n];
		return /* @__PURE__ */ h(e.AppField, {
			name: n,
			children: () => Te(i, r)
		});
	}
	function r({ children: n }) {
		return /* @__PURE__ */ h(e.AppForm, { children: /* @__PURE__ */ h(L, { children: n ?? t.current.submitLabel }) });
	}
	function i(t) {
		return /* @__PURE__ */ h(e.AppForm, { children: /* @__PURE__ */ h(I, { ...t }) });
	}
	function a() {
		return /* @__PURE__ */ ie(re, { children: [
			Object.keys(t.current.fields).map((e) => /* @__PURE__ */ h(n, { name: e }, e)),
			/* @__PURE__ */ h(i, {}),
			t.current.submitLabel && /* @__PURE__ */ h(r, {})
		] });
	}
	return {
		api: e,
		ErrorSummary: i,
		Field: n,
		Form: Ee({
			api: e,
			renderAllFields: a
		}),
		SubmitButton: r
	};
}
//#endregion
//#region src/lib/validation/rules.ts
function Z(e) {
	return typeof e == "object" && !!e && "start" in e && "end" in e;
}
function Oe(e) {
	return q(e) ? e : Z(e) ? e.start : null;
}
function ke(e) {
	return q(e) ? e : Z(e) ? e.end : null;
}
function Q(e) {
	return e == null || e === "" ? !0 : Array.isArray(e) ? e.length === 0 : typeof e == "number" && Number.isNaN(e);
}
function Ae(e) {
	return e === "checkbox" || e === "switch" ? (e) => e === !0 : (e) => !Q(e);
}
function je(e, t, n, r) {
	if (e === "required") return {
		check: Ae(t),
		message: n.required()
	};
	if (e === "email") return {
		check: (e) => typeof e == "string" && _.safeParse(_.pipe(_.string(), _.email()), e).success,
		message: n.email()
	};
	if ("minLength" in e) return {
		check: (t) => typeof t == "string" && t.length >= e.minLength,
		message: e.message ?? n.minLength(e.minLength)
	};
	if ("maxLength" in e) return {
		check: (t) => typeof t == "string" && t.length <= e.maxLength,
		message: e.message ?? n.maxLength(e.maxLength)
	};
	if ("min" in e) {
		let t = e.min;
		return typeof t == "number" ? {
			check: (e) => typeof e == "number" && e >= t,
			message: e.message ?? n.numberMin(t)
		} : {
			check: (e) => {
				let n = Oe(e);
				return n !== null && n.compare(t) >= 0;
			},
			message: e.message ?? n.dateMin(t)
		};
	}
	if ("max" in e) {
		let t = e.max;
		return typeof t == "number" ? {
			check: (e) => typeof e == "number" && e <= t,
			message: e.message ?? n.numberMax(t)
		} : {
			check: (e) => {
				let n = ke(e);
				return n !== null && n.compare(t) <= 0;
			},
			message: e.message ?? n.dateMax(t)
		};
	}
	return "pattern" in e ? {
		check: (t) => typeof t == "string" && e.pattern.test(t),
		message: e.message ?? r ?? n.invalid()
	} : null;
}
function Me(e, t, n, r) {
	let i = [];
	for (let a of e) {
		let e = je(a, t, n, r);
		e && i.push(e);
	}
	return i;
}
//#endregion
//#region src/lib/validation/buildSchema.ts
function Ne(e) {
	return e.includes("required");
}
function Pe(e) {
	return e.filter((e) => typeof e == "object" && "equals" in e);
}
function Fe(e, t, n) {
	let r = {};
	for (let [i, a] of Object.entries(e)) {
		let e = a.validators ?? [], o = Ne(e), s = Me(e, a.type, t, n);
		r[i] = _.pipe(_.unknown(), ...s.map(({ check: e, message: t }) => _.check((t) => !o && Q(t) ? !0 : e(t), t)));
	}
	let i = _.object(r), a = Object.entries(e).flatMap(([e, t]) => Pe(t.validators ?? []).map((t) => ({
		name: e,
		rule: t
	})));
	return a.length === 0 ? i : a.reduce((e, { name: r, rule: i }) => _.pipe(e, _.forward(_.partialCheck([[i.equals], [r]], (e) => e[i.equals] === e[r], i.message ?? n ?? t.invalid()), [r])), i);
}
//#endregion
//#region src/lib/hooks/useForm.ts
var $ = {
	blur: "onBlur",
	change: "onChange",
	submit: "onSubmit"
};
function Ie(e) {
	let t = X(), n = g(e);
	n.current = e;
	let r = g(null);
	r.current ??= he(e.fields);
	let i = $[e.validateOn ?? "blur"], a = R({
		defaultValues: r.current,
		validators: {
			[i]: Fe(e.fields, t, e.validationFallback),
			onSubmitAsync: async ({ value: e, formApi: r }) => {
				try {
					return await n.current.onSubmit(e), null;
				} catch (e) {
					return V(e, r, {
						fallbackMessage: n.current.submitFallback ?? t.submitFailed(),
						fieldMap: n.current.fieldMap
					});
				}
			}
		}
	}), o = g(null);
	return o.current ??= De(a, n), o.current;
}
//#endregion
export { K as FORM_COMMON_NAMESPACE, S as getErrorText, V as toFormErrors, G as toSubmitHandler, R as useAppForm, b as useFieldContext, Ie as useForm, x as useFormContext, X as useFormMessages, Y as useFormTranslation, z as withForm };
